import React from "react";
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import { getFormattedTime } from "./utils/shared/time";
import { getEventCardStatus } from "./utils/shared/eventStatus";
import { getThumbnailUrl } from "./utils/shared/images";
import { EVENT_STATUS, SECTION_TITLES, SECTION_TYPES } from "./constants/event";
import nowPlayingSvg from "../assets/nowPlaying.svg";
import checkScheduleSvg from "../assets/checkSchedule.svg";
import "./epg.scss";

const EPGPlayingNextCard = React.memo(({ event, onFocus, onEnterPress, index, rowId, activeLiveContentId, activeLiveContentType }) => {
    const { thumbnail, title } = event;
    const focusKey = `${SECTION_TYPES.PLAYING_NEXT}-${rowId}-${index}`;

    const { ref, focused } = useFocusable({
        focusKey,
        onEnterPress,
        onFocus: (focusProps) => {
            onFocus({ ...focusProps, index });
        },
        extraProps: { event, focusKey },
    });

    const eventStatus = React.useMemo(() => {
        const activeLiveContent = activeLiveContentId ? { id: activeLiveContentId, contentType: activeLiveContentType } : null;
        return getEventCardStatus(event, activeLiveContent);
    }, [event.schedule_start, event.schedule_end, event.status, event.contentType, activeLiveContentId, activeLiveContentType]);

    const mainStartTime = event.information?.main_start_time || event.schedule_start;
    const isLiveOrComing = event.status === EVENT_STATUS.LIVE || event.status === EVENT_STATUS.COMING;
    const showAutoPlayCopy = isLiveOrComing && index === 0;

    return (
        <div
            ref={ref}
            role="button"
            tabIndex={0}
            className={`eventCard ${focused ? "focusedCard" : ""}`}
            onClick={() => onEnterPress({ event, focusKey })}
            onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") onEnterPress({ event, focusKey }); }}
            style={{ cursor: "pointer" }}
        >
            <div className="imageContainer">
                <img
                    src={getThumbnailUrl(thumbnail)}
                    loading="lazy"
                    decoding="async"
                    className={`eventCardImg ${focused ? "focusedItem" : ""}`}
                    alt={title}
                />
                <div className="subscribedCheck">
                    <img src={checkScheduleSvg} alt="Subscribed" width="36" height="36" />
                </div>
                <div className="liveContainer">
                    <div className={`liveButton ${isLiveOrComing ? "live" : ""} ${eventStatus.isNowPlaying ? "nowPlaying" : ""} ${!isLiveOrComing ? "scheduled" : ""}`}>
                        {eventStatus.isNowPlaying && <img src={nowPlayingSvg} alt="Now playing" />}
                        {eventStatus.isNowPlaying ? EVENT_STATUS.NOW_PLAYING : eventStatus.liveButtonText}
                    </div>
                </div>
            </div>
            {mainStartTime && (
                <p className="eventCardTime">Event Start&nbsp;{getFormattedTime(mainStartTime)}</p>
            )}
            <p className="eventCardTitle">{title}</p>
            <p className="eventCardLabel">{event.label}</p>
            {showAutoPlayCopy && (
                <p className="playingNextAutoPlay">{SECTION_TITLES.AUTO_PLAY_COPY}</p>
            )}
        </div>
    );
});

export default EPGPlayingNextCard;
